import PingFangMediumText from './PingFangMediumText';

export default PingFangMediumText;
